import './App.css';

import { Breadcrumb, Button, Layout, Menu } from 'antd';
import { Route, Switch } from 'react-router-dom'

import {Canvas} from './activities/canvas'
import {Poser} from './activities/poser'
import React from 'react';
// import {Canvas2} from './activities/canvas2'
import {Rig} from './activities/3d/rig'
import logo from './logo.svg';
import {useEffect} from 'react';

const { Header, Content, Footer } = Layout;
function App() {

  useEffect(() => {
    document.body.style.zoom = "100%";
  }, []);

  return (
    <div className="App">


      <Switch>
      {/* <Route exact path="/" component={() => <Canvas height={500} width={700} />} />
      <Route exact path="/exp" component={() => <Canvas2 height={500} width={700}/>} /> */}
      <Route exact path="" component={() => <Poser/>} />
      {/* <Route exact path="/rig" component={Rig} />
      <Route exact path="/canvas" component={() => <Canvas />} /> */}
      {/* <Route component={Landing} /> */}
    </Switch>
    </div>
  );
}
export default App;
